import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';
import classNames from 'classnames';
import some from 'lodash/some'

import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import ModalManager from '@components/Evaluator/ModalManager';

import { getListCoordinators, addCoordinator, updateCoordinator } from '@actions/evaluators';
import { sendActionToBitacora  } from '@actions/bitacora';

import { StatusConst } from '@constants/general';


class Coordinators extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingTable: true,
      btnSubmitLoading: false,
      coordinators: [],
      showModalCoordinator: {
        isVisible: false,
        title: '',
        nombre: '',
        estatus: '',
        correo: '',
        label: '',
        isEdit: false,
        continueAction: null
      }
    };
  }

  async componentDidMount() {
    await this.loadData();
  }

  loadData = async () => {
    const { getListCoordinators, _evaluatorId } = this.props;
    this.setState({ loadingTable: true });
    const response = await getListCoordinators(_evaluatorId);
    // let response = {}
    // response.data = [{"correo":"coordinador-itt1@correo.com","nombre":"Coordinador Intertek 1","estatus":1},{"correo":"coordinador-itt2@correo.com","nombre":"Coordinador Intertek 2","estatus":1},{"correo":"coordinador-itt3@correo.com","nombre":"Coordinador Intertek 3","estatus":0}]
    if (!response?.status) {
      return this.setState({
        coordinators: response.data,
        loadingTable: false,
      });
    }
    return this.setState({ loadingTable: false });
  };


  onAddCoordinatorModal = () => {
    const { t } = this.props
    this.setState({
      showModalCoordinator: {
        isVisible: true,
        value: '',
        title: t('Agregar coordinador'),
        btnOkLabel: t('Agregar'),
        isEdit: false,
        continueAction: (data, justification) => this.onAddCoordinator(data, justification),
      },
    });
  }

  onAddCoordinator = async (data, justification) => {
    const { addCoordinator, _evaluatorId, sendActionToBitacora } = this.props
    const response = await addCoordinator({nombre: data.nombre, correo: data.correo, id_evaluador: _evaluatorId})
    if (!response?.status) {
      const dataBitacora = {
        transactionName: 'altaCoordinador',
        reason: `${data.correo} || ${justification}`,
      }
      await sendActionToBitacora(dataBitacora)
      await this.loadData();
    }
    return this.setState({ btnSubmitLoading: false });
  }

  onEditCoordinatorModal = (detail) => {
    const { t } = this.props
    this.setState({
      showModalCoordinator: {
        isVisible: true,
        nombre: detail.nombre,
        estatus: detail.estatus,
        title: t('Datos del Coordinador'),
        btnOkLabel: t('Guardar'),
        isEdit: true,
        continueAction: (data, justification) => this.onEditCoordinator(data, detail.correo, justification),
      },
    });
  }

  onEditCoordinator = async (data, correo, justification) => {
    const { updateCoordinator, sendActionToBitacora } = this.props
    const response = await updateCoordinator({nombre: data.nombre, estatus: data.estatus, correo})
    if (!response?.status) {
      const dataBitacora = {
        transactionName: 'actCoordinador',
        reason: `${correo} || ${justification}`,
      }
      await sendActionToBitacora(dataBitacora)
      await this.loadData();
    }
    return this.setState({ btnSubmitLoading: false });
  }

  onHideModalCoordinator = () => {
    this.setState({
      showModalCoordinator: {
        isVisible: false,
      },
    });
  };

  columnResponsive = (rowData, detail) => (
    <>
        <span className="p-column-title">{detail.header}</span>
        {rowData[detail.field]}
    </>
  )

  templateEdit = (node, detail) => (
    <div>
      <span className="p-column-title">{detail.header}</span>
      <Button
        type="button"
        icon="pi pi-pencil"
        className="p-button-text"
        style={{ marginRight: '.5em' }}
        onClick={() => this.onEditCoordinatorModal(node)}
      />
    </div>
  );

  templateStatus = (node, detail) => {
    const { t } = this.props
    if (node.estatus === StatusConst.IS_ACTIVE) {
      return (
        <div>
          <span className="p-column-title">{detail.header}</span>
          <i className="pi pi-check p-mr-2"></i>
        </div>
      )
    } else if (node.estatus === StatusConst.IS_SUSPENDED) {
      return (
        <>
          <span className="p-column-title">{detail.header}</span>
          <span className="badge-red"> {t('SUSPENDIDO')} </span>
        </>
      )
    }
  }

  render() {
    const { t } = this.props;
    const { loadingTable, btnSubmitLoading, coordinators, showModalCoordinator } = this.state;

    return (
      <>
        <div className="p-col-12 p-mt-2">
          <DataTable
            value={coordinators}
            lazy
            className="table-languages"
            emptyMessage={t("No existen datos de gestores asociados")}
            loading={loadingTable}
            // stripedRows
          >
            <Column
              header={t('Nombre')}
              field="nombre"
              body={this.columnResponsive}
            />
            <Column
              header={t('Correo electrónico')}
              field="correo"
              body={this.columnResponsive}
              // className="column-action p-mr-4"
            />
            <Column
              header={t('Estatus')}
              field="estatus"
              body={this.templateStatus}
              className="p-text-center-lg"
            />
            <Column
              header={t('Editar')}
              body={this.templateEdit}
              className="column-action p-text-center-lg"
            />
          </DataTable>
        </div>
        <div className="p-col-12 footer-btn">
          <div className="p-d-flex p-jc-end">
            <Button
              label={t('Agregar coordinador')}
              type="button"
              className="p-button-primary"
              onClick={this.onAddCoordinatorModal}
              loading={btnSubmitLoading}
            />
          </div>
          { showModalCoordinator.isVisible && (
            <ModalManager
              display={showModalCoordinator.isVisible}
              title={showModalCoordinator.title}
              nombre={showModalCoordinator.nombre}
              isEdit={showModalCoordinator.isEdit}
              correo={showModalCoordinator.correo}
              estatus={showModalCoordinator.estatus}
              btnOkLabel={showModalCoordinator.btnOkLabel}
              label={showModalCoordinator.label}
              onHidden={() => this.onHideModalCoordinator()}
              onContinueAction={showModalCoordinator.continueAction}
            />
          )}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  _evaluatorId: state.evaluator.id
});

const mapDispatchToProps = {
  getListCoordinators,
  addCoordinator,
  updateCoordinator,
  sendActionToBitacora
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(Coordinators);
